import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import agTableVif from './agTableVif';
import barChartVif from './barChartVif';
import mapVif from './mapVif';
import regionMapVif from './regionMapVif';
import calendarVif from './calendarVif';
import columnChartVif from './columnChartVif';
import comboChartVif from './comboChartVif';
import pieChartVif from './pieChartVif';
import featureMapVif from './featureMapVif';
import histogramVif from './histogramVif';
import scatterChartVif from './scatterChartVif';
import tableVif from './tableVif';
import dataTableVif from './dataTableVif';
import timelineChartVif from './timelineChartVif';
import { Vif } from 'common/visualizations/vif';
import { isTableHeaderWrapEnabled } from 'common/visualizations/helpers/VifSelectors';
import { isEmpty } from 'lodash';

/**
 * Configures wrapHeaders to TRUE for new tables and FALSE for existing tables
 * when enable_table_header_wrapping is enabled.
 */
export const createAgTableVif = (existingVif?: Partial<Vif>) => {
  const baseAgTableVif = cloneDeep(agTableVif);
  const formatting = get(existingVif, 'series[0].formatting');
  // Set wrapHeaders to TRUE by default only for new tables
  if (isEmpty(formatting) && isTableHeaderWrapEnabled()) {
    baseAgTableVif.series[0].formatting.headerFormat = {
      ...baseAgTableVif.series[0].formatting.headerFormat,
      wrapHeaders: true,
    };
  }
  return baseAgTableVif;
};

export default (vif?: Partial<Vif>) =>
  cloneDeep({
    barChart: barChartVif,
    map: mapVif,
    regionMap: regionMapVif,
    calendar: calendarVif,
    columnChart: columnChartVif,
    comboChart: comboChartVif,
    pieChart: pieChartVif,
    featureMap: featureMapVif,
    histogram: histogramVif,
    scatterChart: scatterChartVif,
    table: tableVif,
    dataTable: dataTableVif,
    agTable: createAgTableVif(vif),
    timelineChart: timelineChartVif,
  });
